var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 2.3335C7.77657 2.3335 4.33853 5.65373 4.33853 9.87252V15.0186C4.72493 18.4978 8.05004 21.9857 11.9856 21.9857C15.9212 21.9857 19.2463 18.4978 19.6327 15.0186V9.87252C19.6327 5.65373 16.2233 2.3335 11.9999 2.3335ZM11.9999 2.3335V0.978271M19.6327 10.4071L21.6781 10.4071V12.4071M19.6327 14.4071L21.6781 14.4071V12.4071M4.33853 10.4071H2.3029V12.4071M4.33853 14.4071H2.3029V12.4071M2.3029 12.4071H0.908203M21.6781 12.4071H23.1223",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4998 16.0585H8.49977V18.448H15.4998V16.0585Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99977 13C6.34838 13 6.34838 8 8.99977 8C11.6512 8 11.6512 13 8.99977 13Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 13C12.3484 13 12.3484 8 14.9998 8C17.6512 8 17.6512 13 14.9998 13Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.dc7267ddf86ec3b3d4a2b341665447a1.svg";
export { ForwardRef as ReactComponent };